import React, { Component } from 'react';
import { EmvioCard, EmvioLoadingSpinner } from '@nexio/emvio-util-ui';
import { EmvioButton } from '@nexio/emvio-form-components';
import { requestFraud } from '../fraudActions';
import {
    getIsRequestFraudLoading,
    getIsRequestFraudSuccessful,
    getRequestFraudErrorMessage
} from '../fraudEntity';
import { getIsMerchantsLoading } from '../../Merchants/merchantsEntity';
import { toastIfError } from '../../../utils/toast';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './Marketing.scss';

export class Marketing extends Component {
    static propTypes = {
        error: PropTypes.string,
        isMerchantsLoading: PropTypes.bool,
        isRequestFraudLoading: PropTypes.bool,
        isRequestFraudSuccessful: PropTypes.bool,
        onRequestFraud: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.renderContact = this.renderContact.bind(this);
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'error');
    }

    renderContact() {
        if (this.props.isRequestFraudSuccessful) {
            return (<div className="marketing-contact">
                <div className="feature-requested">
                    Your request has been sent. We will be in contact with you soon.
                </div>
            </div>);
        }

        return (<div className="marketing-contact">
            <div className="contact-blurb">
                Talk to your agent to activate fraud protection triggers
            </div>
            <div className="request-button-wrapper">
                <EmvioButton
                    invertColors
                    isLoading={this.props.isRequestFraudLoading}
                    onClick={this.props.onRequestFraud}>
                    Request This Feature
                </EmvioButton>
            </div>
        </div>);
    }

    render() {
        return (this.props.isMerchantsLoading
            ? <EmvioLoadingSpinner />
            : <EmvioCard className="emvio-fraud-marketing grow-height">
                <div className="overview">
                    <div className="overview-wrapper">
                        <div className="shield-wrapper">
                            <span className="icon-shield" />
                        </div>
                        <div className="marketing-title">
                            Merchants: Empowered
                        </div>
                        <div className="marketing-overview">
                            Through industry leading fraud prevention technology, merchants are empowered to enter new international ecommerce markets.
                        </div>
                    </div>
                </div>
                <div className="features">
                    <div className="features-wrapper">
                        <div className="features-title">
                            Featuring
                        </div>
                        <div className="features-item">
                            Automatically Decline Fraudulent Transactions
                        </div>
                        <div className="features-item">
                            Directly Integrated Into Plugin
                        </div>
                        <div className="features-item">
                            Review Suspicious Transactions
                        </div>
                        <div className="features-item">
                            Decrease Chargebacks
                        </div>
                        <div className="features-overview">
                            {'Through these, and many other fraud prevention features, Nexio can minimize fraud losses and maximize our client\'s processing capacities.'}
                        </div>
                    </div>
                </div>
                {this.renderContact()}
            </EmvioCard>);
    }
}

function mapStateToProps(state) {
    return {
        error: getRequestFraudErrorMessage(state),
        isMerchantsLoading: getIsMerchantsLoading(state),
        isRequestFraudLoading: getIsRequestFraudLoading(state),
        isRequestFraudSuccessful: getIsRequestFraudSuccessful(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onRequestFraud: () => dispatch(requestFraud())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Marketing);
